<template>
  <v-row justify="center">
    <v-dialog
		  v-model="openModal"
			persistent
			max-width="600px"
		>
      <v-card>
        <v-card-title>
          <span class="text-h5">Input Data Tujuan Pengiriman</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field label="Kota" ref="kota" autofocus @keydown.enter="focusRefs('ket')" required v-model="formData.kota"></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="4">
                <v-text-field label="Nama PT" ref="nama" @keydown.enter="focusRefs('cp')" required v-model="formData.nama"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Contact Person" ref="cp" @keydown.enter="focusRefs('ket')" required v-model="formData.cp"></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="12" md="12">
                <v-text-field label="Keterangan" ref="ket" @keydown.enter="createData" required v-model="formData.ket"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text :disabled="loading" tabindex="-1" @click="$emit('close-modal'); resetFormData();">
            Close
          </v-btn>
          <v-btn color="blue darken-1" :loading="loading" text @click="createData">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CreateModal',
  props: ['openModal', 'tempData'],
  data() {
    return {
      formData: {
				kota: '',
				nama: '',
				cp: '',
				ket: ''
      },
      loading: false
    }
  },
  watch: {
    tempData(val) {
      if (val) {
        this.formData.kota = val;
      }
    }
  },
  methods: {
    async createData() {
			this.loading = true;
			
			await axios
				.post(`tujuan-pengiriman`, this.formData)
					.then(res => {
						this.loading = false;
						this.$emit('update-data', res.data);

            this.resetFormData();
					})
					.catch(err => {
            this.loading = false;
            
						alert(err.response.data.message);
					}); 
    },
    resetFormData() {
      this.formData.kota = '';
      this.formData.nama = '';
      this.formData.cp = '';
      this.formData.ket = '';
    },
    focusRefs(id) {
      this.$refs[id].$refs.input.focus();
    },
  },
}
</script>